export const titleCase = (str) => {
  let splitStr;
  if (str) {
    splitStr = str.toLowerCase().split(" ");
  }else{
    return "";
  }
  console.log("split",splitStr);
  let modifiedStr = "";

  for (var i = 0; i < splitStr.length; i++) {
    if (splitStr.length[i] < splitStr.length) {
      splitStr[i].charAt(0).toUpperCase();
    }

    modifiedStr = splitStr.join(" ");
  }

  console.log(modifiedStr);
  return modifiedStr;
}

export const capitalizeFirstLetter = (inputString = null) => {
  let str = inputString?.toLowerCase();
  return str?.charAt(0).toUpperCase() + str?.slice(1);
}

export const numberSuffix = (num) => {
  if (num % 100 >= 11 && num % 100 <= 13) {
    return num + "th"; // Special case for 11th, 12th, 13th
  }

  const lastDigit = num % 10;

  switch (lastDigit) {
    case 1: return num + "st";
    case 2: return num + "nd";
    case 3: return num + "rd";
    default: return num + "th";
  }
}